import { createContext } from 'react';

export const API_BASE_URL = 'https://api.capassurances.net/api/v1';
// export const API_BASE_URL = 'http://localhost:8082/api/v1';
                                 
export const APP_NAME = "CAP_ASSURANCE_BACKOFFICE";
export const LOCAL_STORAGE_KEYS = {
   ACCESS_TOKEN: 'accessToken',
   CURRENT_USER: 'currentUser'
};

export const AuthContext = createContext('AUTH_CONTEXT');
export const AppContext = createContext('APP_CONTEXT');

export * from './statuts';
